import { type RouteObject, Navigate } from 'react-router-dom';
import {
  ApproacherSPage,
  PricingPage,
  SettingsPage,
  NewMemberPage,
  ComunicadosListPage,
  ComunicadoComposerPage,
  AiAppealsPage,
} from '@/modules/admin';
import { PaymentsPage } from '@/modules/payments';
import { AdminRoute } from './route-guards';

export const ADMIN_ROUTES: RouteObject = {
  path: 'admin',
  element: <AdminRoute />,
  children: [
    { index: true, element: <Navigate to="team" replace /> },
    { path: 'team', element: <ApproacherSPage /> },
    { path: 'team/new', element: <NewMemberPage /> },
    { path: 'pricing', element: <PricingPage /> },
    { path: 'settings', element: <SettingsPage /> },
    { path: 'communications', element: <ComunicadosListPage /> },
    { path: 'communications/new', element: <ComunicadoComposerPage /> },
    { path: 'communications/:id/edit', element: <ComunicadoComposerPage /> },
    { path: 'ai/appeals', element: <AiAppealsPage /> },
  ],
};

export const PAYMENTS_ROUTE: RouteObject = {
  path: 'payments',
  element: <AdminRoute />,
  children: [{ index: true, element: <PaymentsPage /> }],
};
